import moment from 'moment';

export function searchDateErrors(start: moment.Moment | null, end: moment.Moment | null, now = moment()) {
    let pickup: string | null = null;
    let returned: string | null = null;
    if (!start?.isValid()) pickup = 'invalidDate';
    else if (start.isBefore(now)) pickup = 'minDateTime';
    if (!end?.isValid()) returned = 'invalidDate';
    else if (end.isBefore(now)) returned = 'minReturnDateTime';
    else if (start?.isValid()) {
        if (end.isBefore(start.clone().add(2, 'hours'))) returned = 'minTime';
        else if (end.isAfter(start.clone().add(60, 'days'))) returned = 'maxDate';
    }
    return {pickup, returned};
}

// Coalesce only currently running identical searches. A settled request is never
// cached: retrying a failure or searching again must get current availability.
export function createSearchRequests<T>() {
    const pending = new Map<string, Promise<T>>();
    return (key: string, request: () => Promise<T>): Promise<T> => {
        const existing = pending.get(key);
        if (existing) return existing;
        const result = Promise.resolve().then(request).finally(() => pending.delete(key));
        pending.set(key, result);
        return result;
    };
}
